import { DEFAULT_SORT_CONFIG } from './shared/configs';

enum SECTION_ENUM {
  MORE_IN_FREE_EXPRESSION = 'More In Free Expression'
}

const SECTION_LABELS = {
  SECTION_TOP: 'Free Expression',
  SECTION_TOP_FIVE_STORIES: 'Free Expression',
  MORE_IN_FREE_EXPRESSION: 'More in Free Expression',
  VIDEO_LIST: 'Video List'
};

const URLS = {
  SECTION_TOP: null,
  SECTION_TOP_FIVE_STORIES: null
};

const BASE_QUERY = {
  ...DEFAULT_SORT_CONFIG,
  query: {
    and: [{ term: { key: 'Product', value: 'Free Expression' } }]
  }
};

const sectionNameQuery = { term: { key: 'SectionName', value: 'Free Expression' } };
const sectionTypeQuery = { term: { key: 'SectionType', value: 'Opinion Journal' } };

const QUERY_CONFIGS = {
  SECTION_TOP: {
    query: { ...BASE_QUERY, count: 1 },
    label: SECTION_LABELS.SECTION_TOP,
    type: null,
    url: URLS.SECTION_TOP
  },
  SECTION_TOP_FIVE_STORIES: {
    query: { ...BASE_QUERY, count: 5 },
    label: SECTION_LABELS.SECTION_TOP_FIVE_STORIES,
    type: null,
    url: URLS.SECTION_TOP_FIVE_STORIES
  },
  VIDEO_LIST: {
    query: {
      ...DEFAULT_SORT_CONFIG,
      query: {
        and: [
          { term: { key: 'ContentType', value: 'video' } },
          { term: { key: 'Product', value: 'wsj opinion video' } },
          { term: { key: 'LanguageCode', value: 'en' } },
          { term: { key: 'ColumnName', value: 'Free expression' } }
        ]
      }
    },
    label: SECTION_LABELS.VIDEO_LIST,
    type: null,
    url: null
  },
  MORE_IN_FREE_EXPRESSION: {
    query: {
      ...BASE_QUERY,
      query: { ...BASE_QUERY.query, and: [...BASE_QUERY.query.and, sectionNameQuery, sectionTypeQuery] },
      count: 5
    },
    label: SECTION_LABELS.MORE_IN_FREE_EXPRESSION,
    type: null,
    url: null
  }
};

export { SECTION_ENUM, BASE_QUERY, SECTION_LABELS, QUERY_CONFIGS };
